import { gql } from '@apollo/client';
import { client } from '../../../../../graphql/client';

export interface DriverPhotosInput {
    idDocumentImageS3Keys: string[];
    vehicleImageS3Keys: string[];
}

export interface UploadPhotoResult {
    accountId: number;
    success: boolean;
    errorMessage?: string;
}

export interface BatchUploadPhotosResponse {
    results: UploadPhotoResult[];
}

const BATCH_UPLOAD_DRIVER_PHOTOS = gql`
    mutation BatchUploadDriverPhotos($accountIds: [Long!]!, $photos: [DriverPhotosInput!]!) {
        batchUploadDriverPhotos(accountIds: $accountIds, photos: $photos) {
            results {
                accountId
                success
                errorMessage
            }
        }
    }
`;

export const batchUploadDriverPhotos = async (
    accountIds: number[],
    photos: Map<number, DriverPhotosInput>
): Promise<BatchUploadPhotosResponse> => {
    // 将 Map 转换为数组格式
    const photosArray = accountIds.map(accountId => {
        const photo = photos.get(accountId);
        if (!photo) {
            throw new Error(`Missing photos for accountId: ${accountId}`);
        }
        return {
            accountId,
            idDocumentImageS3Keys: photo.idDocumentImageS3Keys,
            vehicleImageS3Keys: photo.vehicleImageS3Keys
        };
    });

    const result = await client.mutate({
        mutation: BATCH_UPLOAD_DRIVER_PHOTOS,
        variables: {
            accountIds,
            photos: photosArray
        }
    });

    return result.data.batchUploadDriverPhotos;
};

